module.exports = __webpack_public_path__ + "static/media/instrucciones.c4b5d3bc.png";